/**
 * Dropdown
 * ======================================
 * - mobile only
 * - add class to parent on click
 * - and close others open on mobile
 * - close when clicking on .dropdown__closer
 */

const WIDGET = '.dropdown';
const ACTIVECLASS = 'is-open';
const IS_COARSE = matchMedia('(pointer:coarse)').matches;

export class Dropdown {
  constructor() {
    this.elements = document.querySelectorAll(WIDGET);
  }

  init = () => {
    this.elements.forEach((el) => {
      const button = el.querySelector('.dropdown__btn');
      const closer = el.querySelector('.dropdown__closer');

      if (button) {
        button.addEventListener('click', this.clickHandler, false);
      }

      if (closer) {
        closer.addEventListener('click', this.closeHandler, false);
      }
    });
  };

  clickHandler = (e) => {
    e.stopPropagation();
    const button = e.currentTarget;
    const widget = button.closest(WIDGET);

    if (!widget.classList.contains(ACTIVECLASS)) {
      this.closeSiblings(widget);
    }

    widget.classList.toggle(ACTIVECLASS);
  };

  closeHandler = (e) => {
    e.stopPropagation();
    const closer = e.currentTarget;
    const widget = closer.closest(WIDGET);

    if (widget.classList.contains(ACTIVECLASS)) {
      widget.classList.remove(ACTIVECLASS);
    }
  };

  closeSiblings = (widget) => {
    const parent = widget.parentElement;
    const siblings = parent ? parent.querySelectorAll(`${WIDGET}.${ACTIVECLASS}`) : [];

    siblings.forEach((sibling) => {
      if (sibling !== widget) {
        sibling.classList.remove(ACTIVECLASS);
      }
    });
  };
}

if (IS_COARSE) {
  const DropdownObject = new Dropdown();
  DropdownObject.init();
}
